<div class="select-element-number-container">
  <div class="hits-per-site label-text">
    Treffer pro Seite:
  </div>
  <select #selectElem (change)="changeNumberDisplayedElements(selectElem.value)">
    <option *ngFor="let hits of hitsPerSiteArray" [value]="hits">
      {{hits}}
    </option>
  </select>
</div>
<div class="site-number-container">
  <div class="number-of-elements label-text">
    Anzahl der Treffer: {{maxLengthOfDisplayed}}
  </div>
  <div class="page-indicator-container">
    <a class="page-indicator"
       mat-button
       *ngIf="rangeOfDisplayedPages() == 3"
       (click)="decrementPageRange()">
      &#x3c;
    </a>
    <a class="page-indicator"
       *ngFor="let site of sitesArray | slice: leftSideOfDisplayedPageSelectors : leftSideOfDisplayedPageSelectors + rangeOfDisplayedPages()"
       mat-button (click)="changePage(site)"
       [ngClass]="isCurrentPage(site)?'current-side-button': null">
      {{giveSiteRangeString(site)}}&nbsp;
    </a>
    <div class="deactivated-range-buttons"
         *ngIf="rangeOfDisplayedPages() == 3 && leftSideOfDisplayedPageSelectors + 2 < numberOfPages">
      <a class="page-indicator"
         mat-button disabled>
        ...
      </a>
      <a class="page-indicator"
         mat-button disabled>
        -{{maxLengthOfDisplayed}}
      </a>
    </div>
    <a class="page-indicator"
       mat-button
       *ngIf="rangeOfDisplayedPages() == 3"
       (click)="incrementPageRange()">
      &#x3e;
    </a>
  </div>
</div>
